<template>
  <h2 class="def-h2">
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'DefH2',
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.def-h2 {
  font-weight: 600;
  font-size: rem(18);
  line-height: 125%;
  text-transform: uppercase;
  margin-bottom: 16px;
  @include point-md {
    font-size: rem(20);
  }
  @include point-lg{
    font-size: rem(24);
  }
}
</style>
